// Archoil ExCu_July_26 Customer Survey
// Homepage URL-triggered popup survey for existing customer research.
// Trigger URL: https://www.archoil.com/?ExCu_July_26=1&email={{ person.email|urlencode }}
// Full responses: Google Sheet via Google Apps Script
// Klaviyo: final completion/giveaway marker + products considered only
// Version: v1

(function () {
  'use strict';

  if (window.__archoil_excu_july_26_loaded) return;
  window.__archoil_excu_july_26_loaded = true;

  var SURVEY_CODE = 'ExCu_July_26';
  var SURVEY_CODE_SAFE = 'excu_july_26';
  var SURVEY_VERSION = 'v1';

  var SPREADSHEET_ENDPOINT = 'https://script.google.com/macros/s/AKfycbxIlAWAwwEgcCcdvCQOxcoWACQuYwYOlqx3VvySANcxFHIy8emcWiEh0YmPOvO9gi1NSA/exec';

  var SURVEY_SOURCE = 'Archoil ExCu July 26 Customer Survey';
  var EVENT_ENTERED = 'ExCu July 26 Giveaway Entry';

  var STORAGE_KEY = 'archoil_excu_july_26_state_v1';
  var RUN_ID_KEY = 'archoil_excu_july_26_run_id_v1';
  var TRIGGER_PARAMS = ['ExCu_July_26', 'excu_july_26'];
  var RESET_PARAMS = ['ExCu_July_26_reset', 'excu_july_26_reset'];

  var CONFIG = {
    homepageOnly: true,
    triggerValues: ['', '1', 'true', 'yes', 'test'],

    intro: {
      kicker: 'Customer Giveaway',
      headline: 'Win 1 of 10 Diesel Fuel System Kits',
      subheading: 'Complete this quick 8-question survey and you’ll be entered for your chance to win.',
      button: 'Start Survey',
      image: 'https://cdn.shopify.com/s/files/1/1997/2921/files/Win_DFSK_image.jpg?v=1779894492'
    },

    emailStep: {
      kicker: 'Customer Giveaway',
      headline: 'THANK YOU FOR TAKING PART',
      subheading: 'Enter your email address so we can contact you if you win. Entry closes on July 9. Winners will be contacted before the end of July.',
      button: 'Enter the Giveaway',
      note: 'Your survey answers will help us better understand your vehicles, product needs, and how Archoil can serve you better. Entering your email confirms your entry into the Diesel Fuel System Kit giveaway.',
      image: 'https://cdn.shopify.com/s/files/1/1997/2921/files/Win_DFSK_image-2-02.jpg?v=1780673089'
    },

    completion: {
      kicker: 'Survey Complete',
      headline: 'You’re entered',
      subheading: 'Thanks for completing the survey. Your entry has been recorded. You will be contacted before the end of July if you have won.',
      button: 'Close'
    },

    questions: [
      {
        id: 'products_purchased',
        title: 'Which Archoil products have you purchased?',
        type: 'multi',
        required: true,
        answersToSheetField: 'products_purchased',
        options: [
          { id: 'ar6400_d', label: 'AR6400-D Diesel Fuel System Cleaner' },
          { id: 'ar6500', label: 'AR6500 Diesel Treatment' },
          { id: 'ar9100', label: 'AR9100 Friction Modifier' },
          { id: 'ar6200', label: 'AR6200 Fuel Treatment' },
          { id: 'ar6300', label: 'AR6300 Winter Diesel Treatment' },
          { id: 'ar6400_g', label: 'AR6400-G Gasoline Fuel System Cleaner' }
        ]
      },
      {
        id: 'vehicle_make_model',
        title: 'What vehicle do you use Archoil products in? Please specify make and model.',
        type: 'textarea',
        required: true,
        answersToSheetField: 'vehicle_make_model',
        placeholder: 'Example: 2017 Ford F-250 6.7L Power Stroke, 2005 Ram 2500 Cummins, etc.'
      },
      {
        id: 'satisfaction',
        title: 'How would you describe your level of satisfaction with Archoil products?',
        type: 'textarea',
        required: true,
        answersToSheetField: 'satisfaction',
        placeholder: 'Tell us what has worked well, what has not, or anything you expected to be different.'
      },
      {
        id: 'products_considered',
        title: 'Which other Archoil products would you consider using?',
        type: 'multi',
        required: true,
        noneExclusive: true,
        noneOptionId: 'none',
        answersToSheetField: 'products_considered',
        options: [
          { id: 'ar6400_d', label: 'AR6400-D Diesel Fuel System Cleaner' },
          { id: 'ar6500', label: 'AR6500 Diesel Treatment' },
          { id: 'ar9100', label: 'AR9100 Friction Modifier' },
          { id: 'ar6200', label: 'AR6200 Fuel Treatment' },
          { id: 'ar6300', label: 'AR6300 Winter Diesel Treatment' },
          { id: 'ar6400_g', label: 'AR6400-G Gasoline Fuel System Cleaner' },
          { id: 'none', label: 'None' }
        ]
      },
      {
        id: 'other_diesel_additives_considered',
        title: 'Which other diesel additive products did you consider before choosing Archoil?',
        type: 'textarea',
        required: true,
        answersToSheetField: 'other_diesel_additives_considered',
        placeholder: 'If none, type “None”. Otherwise, list the brand or product names you considered.'
      },
      {
        id: 'other_additive_brands_used',
        title: 'Do you use any other brand of automotive additives other than Archoil, and why?',
        type: 'textarea',
        required: true,
        answersToSheetField: 'other_additive_brands_used',
        placeholder: 'If no, type “No”. If yes, please tell us which brand and why you use it.'
      },
      {
        id: 'product_page_confidence_feedback',
        title: 'Did the Archoil.com product page(s) provide all the information you needed to purchase our product with confidence?',
        subtitle: 'Please detail any information that you felt was missing or incomplete.',
        type: 'textarea',
        required: true,
        answersToSheetField: 'product_page_confidence_feedback',
        placeholder: 'Tell us whether the product pages gave you enough information, and what else would have helped.'
      },
      {
        id: 'purchase_objection',
        title: 'What nearly stopped you buying from us?',
        type: 'textarea',
        required: true,
        answersToSheetField: 'purchase_objection',
        placeholder: 'Tell us what made you think twice about buying Archoil.'
      }
    ]
  };

  var state = {
    started: false,
    index: 0,
    answers: {},
    email: '',
    completed: false,
    giveawayEntry: false,
    lastSpreadsheetStatus: ''
  };

  var partialSendTimer = null;
  var pendingTextPartialQuestion = '';

  function getParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name);
    } catch (_) {
      return null;
    }
  }

  function hasParam(name) {
    try {
      return new URLSearchParams(window.location.search).has(name);
    } catch (_) {
      return false;
    }
  }

  function shouldResetSurvey() {
    for (var i = 0; i < RESET_PARAMS.length; i++) {
      if (hasParam(RESET_PARAMS[i])) return true;
    }
    return false;
  }

  function isHomepage() {
    var path = String(window.location.pathname || '/').replace(/\/+$|^\s+|\s+$/g, '');
    return path === '' || path === '/';
  }

  function shouldOpenSurvey() {
    if (CONFIG.homepageOnly && !isHomepage()) return false;

    for (var i = 0; i < TRIGGER_PARAMS.length; i++) {
      var param = TRIGGER_PARAMS[i];
      if (!hasParam(param)) continue;

      var value = getParam(param);
      value = value == null ? '' : String(value).toLowerCase();

      if (CONFIG.triggerValues.indexOf(value) > -1) return true;
    }

    return false;
  }

  function getEmailFromUrl() {
    var keys = ['email', 'em', 'customer_email', 'kl_email'];

    for (var i = 0; i < keys.length; i++) {
      var value = getParam(keys[i]);
      if (value && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return value.trim();
    }

    return '';
  }

  function getRunId() {
    try {
      var id = localStorage.getItem(RUN_ID_KEY) || sessionStorage.getItem(RUN_ID_KEY);

      if (!id) {
        id = SURVEY_CODE_SAFE + '_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 9);
        localStorage.setItem(RUN_ID_KEY, id);
        sessionStorage.setItem(RUN_ID_KEY, id);
      }

      return id;
    } catch (_) {
      return SURVEY_CODE_SAFE + '_' + Date.now().toString(36);
    }
  }

  function resetStoredSurvey() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (_) {}
    try { localStorage.removeItem(RUN_ID_KEY); } catch (_) {}
    try { sessionStorage.removeItem(RUN_ID_KEY); } catch (_) {}
  }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    attrs = attrs || {};

    Object.keys(attrs).forEach(function (key) {
      var value = attrs[key];

      if (key === 'class') {
        node.className = value;
      } else if (key === 'style') {
        node.setAttribute('style', value);
      } else if (key.indexOf('on') === 0 && typeof value === 'function') {
        node.addEventListener(key.slice(2), value);
      } else if (value !== false && value != null) {
        node.setAttribute(key, value === true ? key : value);
      }
    });

    (children || []).forEach(function (child) {
      node.appendChild(typeof child === 'string' ? document.createTextNode(child) : child);
    });

    return node;
  }

  function clear(node) {
    while (node.firstChild) node.removeChild(node.firstChild);
  }

  function scrollSurveyToTop() {
    try {
      var root = document.querySelector('.excu-root');
      if (root) {
        root.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      var modal = document.querySelector('.excu-modal');
      if (modal) {
        modal.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (_) {}
  }

  function persist() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        started: state.started,
        index: state.index,
        answers: state.answers,
        email: state.email,
        completed: state.completed,
        giveawayEntry: state.giveawayEntry,
        lastSpreadsheetStatus: state.lastSpreadsheetStatus
      }));
    } catch (_) {}
  }

  function restore() {
    try {
      var saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (!saved) return;

      state.started = !!saved.started;
      state.index = Number(saved.index || 0);
      state.answers = saved.answers || {};
      state.email = saved.email || '';
      state.completed = !!saved.completed;
      state.giveawayEntry = !!saved.giveawayEntry;
      state.lastSpreadsheetStatus = saved.lastSpreadsheetStatus || '';
    } catch (_) {}
  }

  function getQuestion(id) {
    for (var i = 0; i < CONFIG.questions.length; i++) {
      if (CONFIG.questions[i].id === id) return CONFIG.questions[i];
    }
    return null;
  }

  function getOptionLabel(question, optionId) {
    if (!question || !question.options) return String(optionId || '');

    for (var i = 0; i < question.options.length; i++) {
      if (question.options[i].id === optionId) return question.options[i].label;
    }

    return String(optionId || '');
  }

  function answerLabel(question, value) {
    if (!question) return '';

    if (question.type === 'multi' && Array.isArray(value)) {
      return value.map(function (id) {
        return getOptionLabel(question, id);
      }).join(', ');
    }

    if (question.type === 'textarea') return String(value || '').trim();

    return getOptionLabel(question, value);
  }

  function answerLabelByQuestionId(questionId) {
    var question = getQuestion(questionId);
    return question ? answerLabel(question, state.answers[questionId]) : '';
  }

  function getTextAnswer(questionId) {
    return String(state.answers[questionId] || '').trim();
  }

  function isAnswered(question) {
    var value = state.answers[question.id];

    if (question.type === 'multi') return Array.isArray(value) && value.length > 0;
    if (question.type === 'textarea') return String(value || '').trim().length > 0;

    return value !== undefined && value !== null && String(value) !== '';
  }

  function knownEmail() {
    return getEmailFromUrl() || state.email;
  }

  function getSpreadsheetPayload(status) {
    var isCompleted = status === 'completed';

    return {
      submitted_at: isCompleted ? new Date().toISOString() : '',
      survey_code: SURVEY_CODE,
      survey_version: SURVEY_VERSION,
      status: status || 'partial',
      run_id: getRunId(),
      email: knownEmail(),
      survey_completed: isCompleted ? 'Yes' : 'No',
      giveaway_entry: isCompleted ? 'Yes' : 'No',
      products_purchased: answerLabelByQuestionId('products_purchased'),
      vehicle_make_model: getTextAnswer('vehicle_make_model'),
      satisfaction: getTextAnswer('satisfaction'),
      products_considered: answerLabelByQuestionId('products_considered'),
      other_diesel_additives_considered: getTextAnswer('other_diesel_additives_considered'),
      other_additive_brands_used: getTextAnswer('other_additive_brands_used'),
      product_page_confidence_feedback: getTextAnswer('product_page_confidence_feedback'),
      purchase_objection: getTextAnswer('purchase_objection'),
      page_url: window.location.href,
      user_agent: navigator.userAgent
    };
  }

  function sendToSpreadsheet(status, immediate) {
    if (!SPREADSHEET_ENDPOINT || SPREADSHEET_ENDPOINT.indexOf('PASTE_') === 0) return;

    var payload = getSpreadsheetPayload(status || 'partial');
    state.lastSpreadsheetStatus = status || 'partial';
    persist();

    try {
      var body = JSON.stringify(payload);

      if (navigator.sendBeacon && immediate) {
        try {
          var blob = new Blob([body], { type: 'text/plain;charset=utf-8' });
          navigator.sendBeacon(SPREADSHEET_ENDPOINT, blob);
          return;
        } catch (_) {}
      }

      if (window.fetch) {
        fetch(SPREADSHEET_ENDPOINT, {
          method: 'POST',
          mode: 'no-cors',
          headers: {
            'Content-Type': 'text/plain;charset=utf-8'
          },
          body: body,
          keepalive: !!immediate
        });
      }
    } catch (_) {}
  }

  function queuePartialSpreadsheetSend(questionId) {
    pendingTextPartialQuestion = questionId || pendingTextPartialQuestion;

    if (partialSendTimer) {
      window.clearTimeout(partialSendTimer);
    }

    partialSendTimer = window.setTimeout(function () {
      partialSendTimer = null;
      pendingTextPartialQuestion = '';
      sendToSpreadsheet('partial', false);
    }, 700);
  }

  function klaviyoIdentify(email, props) {
    if (!email) return;

    try {
      var payload = Object.assign({ email: email, $email: email }, props || {});

      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify(payload);
      } else if (window._learnq) {
        window._learnq.push(['identify', payload]);
      }
    } catch (_) {}
  }

  function klaviyoTrack(eventName, props, email) {
    try {
      var payload = Object.assign({}, props || {});

      if (email) {
        payload.email = email;
        payload.$email = email;
      }

      if (window.klaviyo && typeof window.klaviyo.track === 'function') {
        window.klaviyo.track(eventName, payload);
      } else if (window._learnq) {
        window._learnq.push(['track', eventName, payload]);
      }
    } catch (_) {}
  }

  function getKlaviyoFinalProps() {
    return {
      ExCu_July_26_finished_survey: 'Yes',
      ExCu_July_26_giveaway_entry: 'Yes',
      ExCu_July_26_products_considered: answerLabelByQuestionId('products_considered'),
      ExCu_July_26_survey_version: SURVEY_VERSION
    };
  }

  function sendFinalToKlaviyo(email) {
    var props = getKlaviyoFinalProps();
    var eventProps = Object.assign({}, props, {
      survey_code: SURVEY_CODE,
      survey_version: SURVEY_VERSION,
      survey_source: SURVEY_SOURCE,
      giveaway: 'Diesel Fuel System Kit Giveaway'
    });

    klaviyoIdentify(email, props);
    klaviyoTrack(EVENT_ENTERED, eventProps, email);
  }

  function injectStyles() {
    if (document.getElementById('archoil-excu-july-26-styles')) return;

    var css = '' +
      ':root{--excu-orange:#ff6b00;--excu-gray:#e6e6e6;--excu-text:#111;--excu-muted:#6b7280;--excu-border:#e5e7eb;--excu-bg:#f9fafb}' +
      '.excu-lock{overflow:hidden!important}' +
      '.excu-overlay{position:fixed;inset:0;background:rgba(0,0,0,.62);z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:18px}' +
      '.excu-modal{width:min(1040px,100%);max-height:min(92vh,980px);background:#fff;border-radius:18px;box-shadow:0 24px 80px rgba(0,0,0,.32);position:relative;overflow:visible;display:flex;flex-direction:column}' +
      '.excu-close{position:absolute;right:14px;top:12px;z-index:5;width:42px;height:42px;border-radius:999px;border:1px solid var(--excu-border);background:#fff;color:#111;font-size:26px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center}' +
      '@media(min-width:721px){.excu-close{right:-58px;top:0}}' +
      '.excu-close:hover{box-shadow:0 6px 18px rgba(0,0,0,.12)}' +
      '.excu-root{overflow:auto;-webkit-overflow-scrolling:touch}' +
      '.excu-wrap{max-width:76rem;margin:0 auto;padding:34px 24px 42px;color:var(--excu-text);font-family:"DIN Next LT Pro","DIN Next","DIN",Inter,Arial,sans-serif}' +
      '.excu-kicker{text-transform:uppercase;letter-spacing:.08em;font-size:14px;font-weight:800;color:var(--excu-orange);margin-bottom:8px}' +
      '.excu-h2{font-weight:800;letter-spacing:-.02em;margin:0 0 10px;text-align:center;font-size:28px;line-height:1.1}' +
      '.excu-sub{color:var(--excu-muted);font-size:16px;line-height:1.5;margin:0 auto 20px;max-width:48rem;text-align:center}' +

      '.excu-split-card{max-width:980px;margin:18px auto;padding:0;border:1px solid var(--excu-border);border-radius:18px;background:#fff;overflow:hidden;display:grid;grid-template-columns:1fr 1fr;align-items:stretch}' +
      '.excu-split-media{background:#f3f4f6;min-height:420px;display:flex}' +
      '.excu-split-media img{display:block;width:100%;height:100%;object-fit:cover}' +
      '.excu-split-content{padding:42px 38px;display:flex;flex-direction:column;justify-content:center;text-align:center}' +
      '.excu-intro{max-width:42rem;margin:18px auto;padding:28px 24px;border:1px solid var(--excu-border);border-radius:14px;background:#fff;text-align:center}' +

      '.excu-meta{display:flex;align-items:center;justify-content:space-between;margin:4px 0 8px;color:var(--excu-muted);font-size:14px}' +
      '.excu-progress .track{height:8px;background:var(--excu-gray);border-radius:8px;overflow:hidden}' +
      '.excu-progress .fill{height:100%;background:var(--excu-orange);width:0;transition:width .25s ease}' +
      '.excu-stage{margin-top:22px}' +
      '.excu-question-sub{color:var(--excu-muted);font-size:16px;line-height:1.45;margin:-2px auto 20px;max-width:48rem;text-align:center}' +

      '.excu-options{max-width:56rem;margin:18px auto 0;display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:12px}' +
      '.excu-option{position:relative;min-height:62px;border-radius:14px;border:1px solid #d1d5db;background:#fff;color:#111;cursor:pointer;text-align:left;padding:15px 46px 15px 18px;font-size:16px;font-weight:800;line-height:1.25;box-shadow:0 1px 2px rgba(16,24,40,.04);transition:border-color .2s,box-shadow .2s,background .2s}' +
      '.excu-option:hover{box-shadow:0 8px 22px rgba(0,0,0,.08)}' +
      '.excu-option.selected{border-color:var(--excu-orange);background:#fff7ed}' +
      '.excu-option .check{position:absolute;right:16px;top:50%;transform:translateY(-50%);width:22px;height:22px;border:2px solid #d1d5db;border-radius:6px;background:#fff;display:flex;align-items:center;justify-content:center;color:#fff;font-size:15px;line-height:1}' +
      '.excu-option.selected .check{background:var(--excu-orange);border-color:var(--excu-orange)}' +
      '.excu-selected-count{text-align:center;color:var(--excu-muted);margin-top:12px;font-size:14px}' +

      '.excu-field-card{max-width:50rem;margin:18px auto 0;padding:22px;border:1px solid var(--excu-border);border-radius:16px;background:#fff}' +
      '.excu-label{display:block;font-size:14px;margin-bottom:8px;color:#374151;font-weight:800}' +
      '.excu-textarea{width:100%;min-height:170px;resize:vertical;padding:14px 16px;border:1px solid #d1d5db;border-radius:12px;font-size:16px;line-height:1.45;font-family:inherit;color:#111;background:#fff}' +
      '.excu-textarea:focus,.excu-input:focus{outline:2px solid rgba(255,107,0,.22);border-color:var(--excu-orange)}' +
      '.excu-input{width:100%;padding:14px 16px;border:1px solid #d1d5db;border-radius:12px;font-size:16px;font-family:inherit}' +
      '.excu-input[readonly]{background:#f3f4f6;color:#6b7280;cursor:not-allowed}' +
      '.excu-help{color:var(--excu-muted);font-size:14px;line-height:1.45;margin-top:10px}' +
      '.excu-err{display:none;color:#b91c1c;font-size:14px;margin-top:8px;text-align:left}' +

      '.excu-actions{margin-top:26px;display:grid;grid-template-columns:1fr auto 1fr;align-items:center;gap:14px}' +
      '.excu-btn{display:inline-flex;align-items:center;justify-content:center;border-radius:999px;padding:13px 24px;font-size:17px;font-weight:800;cursor:pointer;border:1px solid #d1d5db;background:#fff;color:#374151;transition:opacity .2s,box-shadow .2s;text-decoration:none;font-family:inherit}' +
      '.excu-btn[disabled]{opacity:.4;cursor:not-allowed}' +
      '.excu-btn-primary{background:var(--excu-orange);color:#fff;border-color:transparent;padding:16px 32px}' +
      '.excu-btn-primary:hover{opacity:.95}' +
      '.excu-back{justify-self:start}' +
      '.excu-primary-wrap{justify-self:center}' +
      '@media(min-width:721px){.excu-email-actions{display:flex!important;flex-direction:column!important;gap:12px!important;align-items:stretch!important}.excu-email-actions .excu-primary-wrap{order:1;width:100%}.excu-email-actions .excu-primary-wrap .excu-btn{width:100%;padding:16px 32px}.excu-email-actions .excu-back{order:2;width:100%;padding:16px 32px;justify-self:auto}.excu-email-actions>div:last-child{display:none}}' +

      '@media(max-width:720px){' +
        '.excu-overlay{padding:0;align-items:stretch}' +
        '.excu-modal{max-height:100vh;border-radius:0;width:100%;height:100vh}' +
        '.excu-wrap{padding:58px 16px 32px}' +
        '.excu-h2{font-size:24px}' +
        '.excu-options{grid-template-columns:1fr;gap:10px}' +
        '.excu-option{min-height:58px;font-size:15px;padding:14px 44px 14px 16px}' +
        '.excu-actions{display:flex;flex-direction:column-reverse;align-items:stretch}' +
        '.excu-btn{width:100%;padding:16px 22px}' +
        '.excu-close{right:10px;top:10px}' +
        '.excu-split-card{grid-template-columns:1fr;max-width:100%;margin:0 auto 18px}' +
        '.excu-split-media{min-height:auto;display:block}' +
        '.excu-split-media img{width:100%;height:auto;aspect-ratio:1/1;object-fit:cover}' +
        '.excu-split-content{padding:24px 18px}' +
        '.excu-field-card{padding:18px}' +
        '.excu-textarea{min-height:180px}' +
      '}' +
      '@media(max-width:420px){.excu-option{font-size:14px}.excu-textarea{font-size:15px}}';

    var style = document.createElement('style');
    style.id = 'archoil-excu-july-26-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function createModal() {
    if (document.getElementById('archoil-excu-july-26-overlay')) return;

    var overlay = el('div', {
      class: 'excu-overlay',
      id: 'archoil-excu-july-26-overlay'
    }, []);

    var modal = el('div', {
      class: 'excu-modal',
      role: 'dialog',
      'aria-modal': 'true',
      'aria-label': 'Archoil customer survey'
    }, []);

    var close = el('button', {
      class: 'excu-close',
      type: 'button',
      'aria-label': 'Close survey',
      onclick: closeSurvey
    }, ['×']);

    var root = el('div', {
      class: 'excu-root',
      id: 'archoil-excu-july-26-root'
    }, []);

    modal.appendChild(close);
    modal.appendChild(root);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);
    document.documentElement.classList.add('excu-lock');

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) closeSurvey();
    });

    document.addEventListener('keydown', handleEsc);
  }

  function handleEsc(event) {
    if (event.key === 'Escape') closeSurvey();
  }

  function closeSurvey() {
    if (partialSendTimer) {
      window.clearTimeout(partialSendTimer);
      partialSendTimer = null;
      if (state.started && !state.completed) sendToSpreadsheet('partial', true);
    }

    var overlay = document.getElementById('archoil-excu-july-26-overlay');
    if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);

    document.documentElement.classList.remove('excu-lock');
    document.removeEventListener('keydown', handleEsc);
  }

  function selectOption(question, optionId) {
    if (question.type !== 'multi') return;

    var current = Array.isArray(state.answers[question.id]) ? state.answers[question.id].slice() : [];
    var exists = current.indexOf(optionId) > -1;
    var noneId = question.noneOptionId || 'none';

    if (exists) {
      current = current.filter(function (id) {
        return id !== optionId;
      });
    } else {
      if (question.noneExclusive && optionId === noneId) {
        current = [noneId];
      } else {
        if (question.noneExclusive) {
          current = current.filter(function (id) {
            return id !== noneId;
          });
        }
        current.push(optionId);
      }
    }

    state.answers[question.id] = current;
    persist();
    sendToSpreadsheet('partial', false);
    render();
  }

  function setTextAnswer(question, value, shouldSend) {
  state.answers[question.id] = String(value || '').slice(0, 5000);
  persist();

  var nextButton = document.querySelector('.excu-primary-wrap .excu-btn-primary');

  if (nextButton && question.required) {
    if (isAnswered(question)) {
      nextButton.removeAttribute('disabled');
    } else {
      nextButton.setAttribute('disabled', 'disabled');
    }
  }

  if (shouldSend) {
    queuePartialSpreadsheetSend(question.id);
  }
}

  function renderIntro(root) {
    var wrap = el('div', { class: 'excu-wrap' }, []);
    var card = el('div', { class: 'excu-split-card' }, []);

    var media = el('div', { class: 'excu-split-media' }, []);
    if (CONFIG.intro.image) {
      media.appendChild(el('img', {
        src: CONFIG.intro.image,
        alt: 'Diesel Fuel System Kit giveaway'
      }, []));
    }

    var content = el('div', { class: 'excu-split-content' }, []);
    content.appendChild(el('div', { class: 'excu-kicker' }, [CONFIG.intro.kicker]));
    content.appendChild(el('h2', { class: 'excu-h2' }, [CONFIG.intro.headline]));
    content.appendChild(el('p', { class: 'excu-sub' }, [CONFIG.intro.subheading]));
    content.appendChild(el('button', {
      class: 'excu-btn excu-btn-primary',
      type: 'button',
      onclick: function () {
        state.started = true;
        state.index = 0;
        persist();
        sendToSpreadsheet('partial', false);
        render();
        scrollSurveyToTop();
      }
    }, [CONFIG.intro.button]));

    card.appendChild(media);
    card.appendChild(content);
    wrap.appendChild(card);
    root.appendChild(wrap);
  }

  function renderProgress(wrap, idx, total) {
    var progress = Math.round((idx / Math.max(1, total)) * 100);

    wrap.appendChild(el('div', { class: 'excu-meta' }, [
      el('div', {}, ['Question ', String(idx + 1), ' of ', String(total)]),
      el('div', {}, [String(progress), '%'])
    ]));

    wrap.appendChild(el('div', { class: 'excu-progress' }, [
      el('div', { class: 'track' }, [
        el('div', { class: 'fill', style: 'width:' + progress + '%' }, [])
      ])
    ]));
  }

  function renderQuestion(root) {
    var questions = CONFIG.questions;
    var idx = Math.max(0, Math.min(state.index, questions.length - 1));
    state.index = idx;

    var question = questions[idx];
    var wrap = el('div', { class: 'excu-wrap' }, []);

    renderProgress(wrap, idx, questions.length);

    var stage = el('div', { class: 'excu-stage' }, []);
    stage.appendChild(el('h2', { class: 'excu-h2' }, [question.title]));

    if (question.subtitle) {
      stage.appendChild(el('p', { class: 'excu-question-sub' }, [question.subtitle]));
    }

    if (question.type === 'multi') {
      renderMultiQuestion(stage, question);
    } else if (question.type === 'textarea') {
      renderTextQuestion(stage, question);
    }

    renderQuestionActions(stage, question, idx, questions.length);

    wrap.appendChild(stage);
    root.appendChild(wrap);
  }

  function renderMultiQuestion(stage, question) {
    var opts = el('div', { class: 'excu-options' }, []);

    (question.options || []).forEach(function (option) {
      var selected = Array.isArray(state.answers[question.id]) && state.answers[question.id].indexOf(option.id) > -1;

      opts.appendChild(el('button', {
        class: 'excu-option' + (selected ? ' selected' : ''),
        type: 'button',
        onclick: function () {
          selectOption(question, option.id);
        }
      }, [
        option.label,
        el('span', { class: 'check', 'aria-hidden': 'true' }, [selected ? '✓' : ''])
      ]));
    });

    stage.appendChild(opts);

    var count = Array.isArray(state.answers[question.id]) ? state.answers[question.id].length : 0;
    stage.appendChild(el('div', { class: 'excu-selected-count' }, ['Selected ', String(count)]));
  }

  function renderTextQuestion(stage, question) {
    var field = el('div', { class: 'excu-field-card' }, []);

    var textarea = el('textarea', {
      class: 'excu-textarea',
      maxlength: '5000',
      placeholder: question.placeholder || 'Type your answer here',
      oninput: function () {
        setTextAnswer(question, textarea.value, false);
      },
      onchange: function () {
        setTextAnswer(question, textarea.value, true);
      },
      onblur: function () {
        setTextAnswer(question, textarea.value, true);
      }
    }, []);

    textarea.value = String(state.answers[question.id] || '');

    field.appendChild(textarea);
    field.appendChild(el('div', { class: 'excu-help' }, ['Required']));
    stage.appendChild(field);
  }

  function renderQuestionActions(stage, question, idx, total) {
    var actions = el('div', { class: 'excu-actions' }, []);

    var back = el('button', {
      class: 'excu-btn excu-back',
      type: 'button',
      onclick: function () {
        if (question.type === 'textarea') sendToSpreadsheet('partial', false);
        state.index = Math.max(0, state.index - 1);
        persist();
        render();
        scrollSurveyToTop();
      }
    }, ['< Back']);

    if (idx === 0) back.setAttribute('disabled', 'disabled');

    var canProceed = !question.required || isAnswered(question);
    var nextText = idx === total - 1 ? 'Continue' : 'Next Question';

    var next = el('button', {
      class: 'excu-btn excu-btn-primary',
      type: 'button',
      onclick: function () {
  var liveCanProceed = !question.required || isAnswered(question);
  if (!liveCanProceed) return;

  sendToSpreadsheet('partial', false);

        if (state.index < total - 1) {
          state.index++;
        } else {
          state.index = total;
        }

        persist();
        render();
        scrollSurveyToTop();
      }
    }, [nextText]);

    if (!canProceed) next.setAttribute('disabled', 'disabled');

    actions.appendChild(back);
    actions.appendChild(el('div', { class: 'excu-primary-wrap' }, [next]));
    actions.appendChild(el('div', {}, []));

    stage.appendChild(actions);
  }

  function renderEmailStep(root) {
    var wrap = el('div', { class: 'excu-wrap' }, []);

    wrap.appendChild(el('div', { class: 'excu-meta' }, [
      el('div', {}, ['Final step']),
      el('div', {}, ['100%'])
    ]));

    wrap.appendChild(el('div', { class: 'excu-progress' }, [
      el('div', { class: 'track' }, [
        el('div', { class: 'fill', style: 'width:100%' }, [])
      ])
    ]));

    var card = el('div', { class: 'excu-split-card' }, []);

    var media = el('div', { class: 'excu-split-media' }, []);
    if (CONFIG.emailStep.image) {
      media.appendChild(el('img', {
        src: CONFIG.emailStep.image,
        alt: 'Enter the giveaway'
      }, []));
    }

    var content = el('div', { class: 'excu-split-content' }, []);
    content.appendChild(el('div', { class: 'excu-kicker' }, [CONFIG.emailStep.kicker]));
    content.appendChild(el('h2', { class: 'excu-h2', style: 'margin-bottom:8px' }, [CONFIG.emailStep.headline]));
    content.appendChild(el('p', { class: 'excu-sub' }, [CONFIG.emailStep.subheading]));

    var emailFromUrl = getEmailFromUrl();
    var lockedEmail = !!emailFromUrl;

    var emailInput = el('input', {
      class: 'excu-input',
      type: 'email',
      autocomplete: 'email',
      placeholder: 'Email address',
      value: emailFromUrl || state.email || '',
      readonly: lockedEmail
    }, []);

    var err = el('div', { class: 'excu-err' }, ['Please enter a valid email address.']);

    content.appendChild(el('label', {
      class: 'excu-label',
      style: 'text-align:left;max-width:34rem;margin:0 auto 8px;'
    }, ['Email address']));

    content.appendChild(el('div', {
      style: 'max-width:34rem;margin:0 auto;width:100%;'
    }, [emailInput]));

    content.appendChild(err);
    content.appendChild(el('div', { class: 'excu-help' }, [CONFIG.emailStep.note]));

    var actions = el('div', {
      class: 'excu-actions excu-email-actions',
      style: 'max-width:34rem;margin:20px auto 0;width:100%;'
    }, []);

    var back = el('button', {
      class: 'excu-btn excu-back',
      type: 'button',
      onclick: function () {
        state.index = CONFIG.questions.length - 1;
        persist();
        render();
        scrollSurveyToTop();
      }
    }, ['< Back']);

    var submit = el('button', {
      class: 'excu-btn excu-btn-primary',
      type: 'button',
      onclick: function () {
        var email = emailFromUrl || String(emailInput.value || '').trim();

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          err.style.display = 'block';
          emailInput.focus();
          return;
        }

        err.style.display = 'none';
        state.email = email;
        state.completed = true;
        state.giveawayEntry = true;

        persist();
        sendToSpreadsheet('completed', true);
        sendFinalToKlaviyo(email);

        render();
        scrollSurveyToTop();
      }
    }, [CONFIG.emailStep.button]);

    actions.appendChild(back);
    actions.appendChild(el('div', { class: 'excu-primary-wrap' }, [submit]));
    actions.appendChild(el('div', {}, []));

    content.appendChild(actions);

    card.appendChild(media);
    card.appendChild(content);
    wrap.appendChild(card);
    root.appendChild(wrap);
  }

  function renderCompletion(root) {
    var wrap = el('div', { class: 'excu-wrap' }, []);

    var intro = el('div', { class: 'excu-intro' }, []);
    intro.appendChild(el('div', { class: 'excu-kicker' }, [CONFIG.completion.kicker]));
    intro.appendChild(el('h2', { class: 'excu-h2' }, [CONFIG.completion.headline]));
    intro.appendChild(el('p', { class: 'excu-sub' }, [CONFIG.completion.subheading]));

    intro.appendChild(el('button', {
      class: 'excu-btn excu-btn-primary',
      type: 'button',
      onclick: closeSurvey
    }, [CONFIG.completion.button]));

    wrap.appendChild(intro);
    root.appendChild(wrap);
  }

  function render() {
    var root = document.getElementById('archoil-excu-july-26-root');
    if (!root) return;

    clear(root);

    if (state.completed) return renderCompletion(root);
    if (!state.started) return renderIntro(root);
    if (state.index >= CONFIG.questions.length) return renderEmailStep(root);

    return renderQuestion(root);
  }

  function start() {
    if (!shouldOpenSurvey()) return;

    if (shouldResetSurvey()) {
      resetStoredSurvey();
    }

    injectStyles();
    restore();

    state.email = getEmailFromUrl() || state.email;
    persist();

    createModal();
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
